import { render, staticRenderFns } from "./livestockSummaryHeifers.vue?vue&type=template&id=666a7af1&scoped=true&"
import script from "./livestockSummaryHeifers.vue?vue&type=script&lang=js&"
export * from "./livestockSummaryHeifers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666a7af1",
  null
  
)

export default component.exports